var image_viewer_rtlignore_default = {
  "fontElementMap": "OJ2BQ",
  "imageContainer": "hB-fH",
  "expandButton": "a--6C",
  "expandIcon": "f7w-W",
  "pointer": "ZBhxI",
  "imageWrapper": "hHMQQ",
  "imageRatio": "tQvAZ",
  "image": "MFya1",
  "imageOverlay": "IFauf",
  "imagePreload": "JSs-6",
  "imageHighres": "ohzRJ",
  "onlyHighRes": "_2X1P8",
  "image_loading": "p-YkH"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
